import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, inject, Injectable } from '@angular/core';
import { AuditService } from '../services/audit.service';
import * as Sentry from '@sentry/angular';

@Injectable()
export class NeoErrorHandler extends ErrorHandler {
   private cachedError: any = {};
   private auditService = inject(AuditService);

   constructor() {
      super();
   }

   override handleError(error: any): void {
      const cachedErrorString = this.cachedError ? this.cachedError.toString() : '';

      if (!(error instanceof HttpErrorResponse) && error.toString() !== cachedErrorString) {
         this.auditService.createAudit(() => `Client error thrown: "${error}"`);
         this.cachedError = error;
      }

      if(error.error === null) {
         const { message, status, url, error: body, name, ok } = error;
         Sentry.captureException(new Error(message), {
            extra: {
               status,
               url,
               body,
               name,
               ok
            }
         });
      } else {
         Sentry.captureException(error);
      }

      super.handleError(error);
   }
}
